import { render, staticRenderFns } from "./Requisitions.vue?vue&type=template&id=ccc6a82e&scoped=true"
import script from "./Requisitions.vue?vue&type=script&lang=js"
export * from "./Requisitions.vue?vue&type=script&lang=js"
import style0 from "./Requisitions.vue?vue&type=style&index=0&id=ccc6a82e&prod&scoped=true&lang=css"
import style1 from "./Requisitions.vue?vue&type=style&index=1&id=ccc6a82e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc6a82e",
  null
  
)

export default component.exports